import {useQuery} from '@tanstack/react-query';

import {getGeoFilter} from '../api';
import {QUERY__GEO_FILTER_OPTIONS} from '../queryKeys';
import {GeoFilter} from '../types';

import {QueryOptionsForOne} from '@/shared/api';

export const useGetGeoFilter = <SelectedData = GeoFilter>(
  slug: string,
  options?: QueryOptionsForOne<GeoFilter, SelectedData>,
) => {
  return useQuery({
    queryKey: [QUERY__GEO_FILTER_OPTIONS, slug],
    queryFn: () => getGeoFilter(slug),
    ...options,
  });
};
